// extracted by mini-css-extract-plugin
module.exports = {"left":"left-block_left__oC8DS","scroll":"left-block_scroll__t30hM"};